import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

const NameSlogan = props => {
  const { onDataNameSlogan } = props;

  useEffect(() => {
    onDataNameSlogan();
  }, [onDataNameSlogan]);

  return (
    <hgroup className="ml-10">
      <h1>
        <p className="text-green text-4xl">{props.nameSlogan.name}</p>
        <p className="text-2xl text-gray-500">{props.nameSlogan.slogan}</p>
      </h1>
    </hgroup>
  );
}

const mapsStateToProps = state => {
  return {
    nameSlogan: state.nameSlogan,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onDataNameSlogan: () => dispatch(actions.getName())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(NameSlogan);
